import {SINGLETON_CLASS} from "@kta20-core/constants";
import {IAppContext} from "@kta20-core/interfaces/i-app-context";
import {IAppContextService} from "@kta20-core/interfaces/i-app-context-service";

export class AppContextService implements IAppContextService {

    static get(appContext?:IAppContext): AppContextService {
        if (!this.inst) {
            this.inst = new AppContextService();
            this.inst.appContext = appContext;
        }

        return this.inst;
    }

    private static inst:AppContextService;

    appContext: IAppContext;

    constructor() {
        if (AppContextService.inst) throw new Error(SINGLETON_CLASS);
    }

}